
Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.NearLocations = (function () {

    function NearLocations() {

        this.locationItemColorNumber = 0;
        this.options = null;
        this.DOMContainer = null;
        this.stopTypeLookup = null;
        this.routeId = Monet.Utils.GetTabName().replace('RouteDetails_', '');

        this.init = function (options) {

            this.options = options;

            this.createPanelBasis();
            this.addEquipmentRadiusToMap();
            this.createLocationListContainer();
            this.getNearLocations();

        };

        this.getNearLocations = function () {

            var distanceField = this.panelBasis.querySelector('input.numberPicker');
            var keyField = this.panelBasis.querySelector('.nearLocationFilterByField');

            var distanceNumber = (distanceField.value.trim() === '') ? 0 : parseFloat(distanceField.value);
            var defaultDist = (Monet.Session.User.unitSystem === 'NON_METRIC') ? 1609.34 : 500;
            var converDist = (Monet.Session.User.unitSystem === 'NON_METRIC') ? distanceNumber * 1609.34 : distanceNumber * 1000;

            distanceNumber = isNaN(distanceNumber) ? defaultDist : converDist;

            var request = new Monet.Ajax();
            request.url = '/Location/Near/Search';
            request.method = 'POST';
            request.data = {
                key: keyField.value,
                position: {
                    longitude: this.options.markerEl._latlng.lng,
                    latitude: this.options.markerEl._latlng.lat
                },
                distanceMeters: distanceNumber
            };

            request.success = function (locations) {
                this.popularWithLocationList(locations);
            }.bind(this);

            request.error = function () {
                return true;
            };

            request.send();

        };

        this.createPanelBasis = function () {

            var tabContainer = document.getElementById(Monet.Utils.GetTabName());

            this.mapContainer = document.getElementById('routeMapContainer_' + this.routeId);
            this.DOMContainer = tabContainer.querySelector('.containerRouteDetail');

            const panelBasisElement = document.querySelector('.nearLocationPanelBasis');
            this.panelBasis = panelBasisElement ? panelBasisElement : document.createElement('div');
            this.panelBasis.className = 'nearLocationPanelBasis';

            var headerContainer = document.createElement('div');
            var header = document.createElement('div');
            var title = document.createElement('div');
            var titleClose = document.createElement('div');

            headerContainer.className = 'nearLocationPanelPanelHeaderContainer';
            header.className = 'nearLocationPanelPanelHeader';
            title.className = 'nearLocationPanelPanelTitle';
            titleClose.className = 'nearLocationPanelPanelTitleClose';
            titleClose.title = Monet.I18n.getResourcesByKey('default.button.close');

            title.innerHTML = Monet.I18n.getResourcesByKey('RouteSummary.nearLocations.title');

            titleClose.addEventListener('click', this.toggleMapSize.bind(this));

            headerContainer.appendChild(header);
            headerContainer.appendChild(this.createPanelFilter());

            header.appendChild(title);
            header.appendChild(titleClose);

            this.panelBasis.appendChild(headerContainer);

            this.DOMContainer.appendChild(this.panelBasis);

            this.toggleMapSize();

        };

        this.resizeGrid = function () {
            const grid = App.Forms[Monet.Utils.GetTabName()].table;
            grid.resizeCanvas();
            grid.invalidate();
        };

        this.toggleMapSize = function () {
            var isToCloseTab = this.DOMContainer.style.left === '300px';

            if (isToCloseTab) {

                this.DOMContainer.style.left = '0';
                this.mapContainer.style.left = '0';

                this.DOMContainer.removeChild(this.panelBasis);

                this.clearPreviusRadiusFromMap();
                this.clearLocationMarkers();

            } else {

                this.DOMContainer.style.left = '300px';
                this.mapContainer.style.left = '300px';

            }

            this.adjustToolBarItens(isToCloseTab);

            this.resizeGrid();

        };

        this.adjustToolBarItens = function(isToCloseTab) {
            if (!isToCloseTab) {
                this.DOMContainer.classList.add("containerRouteDetail__with-side-bar");
            } else {
                this.DOMContainer.classList.remove("containerRouteDetail__with-side-bar");
            }
        };

        this.createPanelFilter = function () {

            var panelFilterContainer = document.createElement('div');
            panelFilterContainer.className = 'nearLocationPanelFilter';
            var radiusUnit = Monet.I18n.getResourcesByKey('UnitSystems.Kilometers.abbreviation');

            if (Monet.Session.User.unitSystem === 'NON_METRIC') {
                radiusUnit = Monet.I18n.getResourcesByKey('UnitSystems.Miles.abbreviation');
            }

            var filterRadiusLabel = document.createElement('div');
            var filterByField = document.createElement('input');
            var filterRadiusField = new Monet.UI.Fields.Number();

            filterRadiusField.initializeSpecialBehavior = (function (scope) {
                return function () {
                    $(this.input).stepper({
                        limit:[0, 50],
                        arrowStep: 0.5,
                        wheelStep: 0.5,
                        onStep: function () {
                            scope.addEquipmentRadiusToMap();
                            scope.setMaxDistanceValue(this[0]);
                            scope.requestNearLocations({
                                target: this[0]
                            });
                        },
                        onKeyUp: function () {
                            scope.setMaxDistanceValue(this[0]);
                            scope.addEquipmentRadiusToMap();
                            scope.requestNearLocations({
                                target: this[0]
                            });
                        }
                    });
                };
            }(this));

            filterRadiusField.setValue(5);

            filterRadiusField.render();

            filterRadiusLabel.innerHTML = Monet.I18n.getResourcesByKey('SmartGeocode.filter.radius') + ': (' + radiusUnit + ')';

            filterRadiusLabel.className = 'nearLocationFilterRadiusLabel';
            filterByField.className = 'nearLocationFilterByField';

            filterByField.addEventListener('keyup', this.requestNearLocations.bind(this));

            panelFilterContainer.appendChild(filterByField);
            panelFilterContainer.appendChild(filterRadiusLabel);
            panelFilterContainer.appendChild(filterRadiusField.rootEl);

            return panelFilterContainer;

        };

        this.requestNearLocations = function (e) {

            clearInterval(this.timeoutToken);

            this.timeoutToken = setTimeout((function (value, scope) {
                return function () {
                    scope.clearCurrentLocationsFromLocationList();
                    scope.clearLocationMarkers();
                    scope.getNearLocations();
                };
            }(e.target.value.trim(), this)), 400);

        };

        this.createLocationListContainer = function () {

            this.panelFilterLocationsList = document.createElement('div');

            this.panelFilterLocationsList.className = 'nearLocationPanelLocationList';

            this.panelBasis.appendChild(this.panelFilterLocationsList);

        };

        this.popularWithLocationList = function (locations) {

            var color;

            var fragment = document.createDocumentFragment();

            for (var i = 0, len = locations.length; i < len; i++) {

                color = this.getLocationItemListColor();
                fragment.appendChild(this.createLocationItemList(locations[i], color));
                this.addLocationsToMap(locations[i], color);
            }

            this.panelFilterLocationsList.innerHTML = '';
            this.panelFilterLocationsList.appendChild(fragment);

        };

        this.getLocationItemListColor = function () {

            var colors = ['#4aba71', '#ee3c25', '#fff200', '#00aeff', '#ff7238', '#b0d25a', '#5ad1d2', '#c1bfbf', '#f090bb', '#34425b', '#f26222', '#88d6f7', '#ef4770', '#8bb03e', '#7f898f'];
            var color;

            if (this.locationItemColorNumber < colors.length) {
                color = colors[this.locationItemColorNumber];
                this.locationItemColorNumber += 1;
            } else {
                this.locationItemColorNumber = 0;
                color = colors[this.locationItemColorNumber];
            }

            return color;

        };

        this.createLocationItemList = function (item, color) {

            var map = Monet.Session.RouteDetail.screensList[this.routeId].map;
            var convertedDistance = (Monet.Session.User.unitSystem === 'NON_METRIC') ? item.distanceInMiles.toFixed(2) : item.distanceInKilometers.toFixed(2);
            var distanceString = convertedDistance + ' ' + ((Monet.Session.User.unitSystem === 'NON_METRIC') ? Monet.I18n.getResourcesByKey('UnitSystems.Miles.abbreviation') : Monet.I18n.getResourcesByKey('UnitSystems.Kilometers.abbreviation'));
            var address1 = (typeof item.location.addressLine1 === 'undefined') ? '' : item.location.addressLine1 + ' - ';
            var address2 = (typeof item.location.addressLine2 === 'undefined') ? '' : item.location.addressLine2 + ' - ';
            var city = (typeof item.location.city === 'undefined') ? '' : item.location.city + ' - ';
            var state = (typeof item.location.state === 'undefined') ? '' : item.location.state + '<br/>';
            var phone1 = (typeof item.location.phone1 === 'undefined') ? '' : item.location.phone1 + ' - ';
            var phone2 = (typeof item.location.phone2 === 'undefined') ? '' : item.location.phone2 + '<br/>';

            var locationItem = document.createElement('div');
            var locationColor = document.createElement('div');
            var locationKey = document.createElement('div');
            var distances = document.createElement('div');
            var fullAddress = document.createElement('div');
            var arrowExpand = document.createElement('div');
            var assignToRoute = document.createElement('div');

            locationItem.id = 'near-locations-list-item-' + item.location.id;

            locationColor.className = 'nearLocationColor';
            locationItem.className = 'nearLocationListItem';
            locationKey.className = 'nearLocationListItemLocationKey';
            distances.className = 'nearLocationListItemDistance';
            fullAddress.className = 'nearLocationListItemAddress';
            arrowExpand.className = 'nearLocationListItemArrow';
            assignToRoute.className = 'nearLocationListItemAssignToRoute';

            assignToRoute.title = Monet.I18n.getResourcesByKey('RouteDetail.NearCostumers.AddStopToRoute');

            locationItem.addEventListener('click', (function (data, map) {
                return function () {

                    map.panTo({
                        lon: data.location.longitude,
                        lat: data.location.latitude
                    });

                };
            }(item, map)));

            arrowExpand.addEventListener('click', (function (locationItem, arrowExpand, assignToRoute, scope) {
                return function (e) {
                    e.stopPropagation();
                    scope.expandItem(locationItem, arrowExpand, assignToRoute);
                };
            }(locationItem, arrowExpand, assignToRoute, this)));

            assignToRoute.addEventListener('click', (function (scope, item) {
                return function (e) {
                    e.stopPropagation();
                    scope.addToRouteModal(item);
                };
            }(this, item)));

            locationColor.style.background = color;
            fullAddress.style.display = 'none';

            locationKey.innerHTML = item.location.key;
            if (item.location.description) {
                locationKey.innerHTML += " - " + item.location.description;
            }

            distances.innerHTML = distanceString;
            fullAddress.innerHTML = '<p class="near-locations-marker-text">' + address1 + address2 + city + state + phone1 + phone2 + '</p>';

            locationItem.appendChild(locationColor);
            locationItem.appendChild(locationKey);
            locationItem.appendChild(distances);
            locationItem.appendChild(fullAddress);
            locationItem.appendChild(arrowExpand);
            locationItem.appendChild(assignToRoute);

            return locationItem;

        };

        this.expandItem = function (locationItem, arrowExpand, assignToRoute) {

            var content = locationItem.querySelector('.nearLocationListItemAddress');

            if (arrowExpand.style.transform === 'rotate(0deg)' || arrowExpand.style.transform === '') {

                locationItem.style.height = '';
                arrowExpand.style.transform = 'rotate(90deg)';
                content.style.display = 'block';
                assignToRoute.style.display = 'block';

            } else {

                locationItem.style.backgroundColor = 'transparent';
                locationItem.style.height = '';
                content.style.display = 'none';
                assignToRoute.style.display = 'none';
                arrowExpand.style.transform = 'rotate(0deg)';

            }
        };

        this.addLocationsToMap = function (item, color) {

            var location = {};
            if (item.location) {
                location = item.location;
            }

            var map = Monet.Session.RouteDetail.screensList[this.routeId].map;

            L.NearLocationIcon = L.Icon.extend({

                options: {
                    popupAnchor: new L.Point(45, 10)
                },

                createIcon: function () {

                    var div = document.createElement('div');

                    div.className = 'near-locations-marker';
                    div.style.backgroundColor = color;
                    div.style.width = '12px';
                    div.style.height = '12px';

                    return div;
                }

            });

            var myIcon = new L.NearLocationIcon();

            var marker = L.marker([item.location.latitude || item.latitude, item.location.longitude || item.longitude], {
                icon: myIcon
            });

            marker.kind = 'NEAR_CUSTOMER';

            var popUpHTML = '<h4 class="near-locations-marker-title">' + (location.key || "") + '</h4>';
            popUpHTML += '<p class="near-locations-marker-text">';
            if (location.addressLine1) {
                popUpHTML += location.addressLine1 + ' - ';
            }

            if (location.addressLine2) {
                popUpHTML += location.addressLine2 + ' - ';
            }

            if (location.city) {
                popUpHTML += location.city;
            }

            if (location.state) {
                popUpHTML += " - " + location.state;
            }

            popUpHTML += '<br/>';

            if (location.phone1) {
                popUpHTML += location.phone1;
            }

            if (location.phone2) {
                popUpHTML += ' - ' + location.phone2;
            }

            popUpHTML += '</p>';
            marker.bindPopup(popUpHTML);

            marker.addTo(map);

        };

        this.addEquipmentRadiusToMap = function () {

            var map = Monet.Session.RouteDetail.screensList[this.routeId].map;
            var distanceString = this.panelBasis.querySelector('input.numberPicker').value;
            var distanceNumber = (distanceString.trim() === '') ? 0 : parseFloat(distanceString);
            var position = this.options.markerEl.getLatLng();
            var defaultDist = (Monet.Session.User.unitSystem === 'NON_METRIC') ? 1609.34 : 500;
            var converDist = (Monet.Session.User.unitSystem === 'NON_METRIC') ? distanceNumber * 1609.34 : distanceNumber * 1000;

            distanceNumber = isNaN(distanceNumber) ? defaultDist : converDist;

            this.clearPreviusRadiusFromMap();

            var circleLayer = L.circle([position.lat, position.lng], distanceNumber, {
                color: '#04d412',
                fillColor: '#04d412',
                fillOpacity: 0.3,
                strokeOpacity: 1,
                strokeWidth: 3
            });

            circleLayer.kind = 'NEAR_CUSTOMER_CIRCLE';

            circleLayer.addTo(map);

        };

        this.clearPreviusRadiusFromMap = function () {

            var map = Monet.Session.RouteDetail.screensList[this.routeId].map;

            for (var layer in map._layers) {
                if (map._layers[layer].kind === 'NEAR_CUSTOMER_CIRCLE') {
                    map.removeLayer(map._layers[layer]);
                }
            }

        };

        this.setMaxDistanceValue = function (field) {

            var fieldValue = (field.value.trim() === '') ? 0 : parseFloat(field.value.trim());

            if (fieldValue > 50) {
                field.value = 50;
            }

        };

        this.setDefaultDistanceValue = function (e) {

            var field = e.target;
            var fieldValue = field.value.trim();

            if (fieldValue === '' || isNaN(parseFloat(fieldValue))) {
                field.value = 0.5;
            }

        };

        this.clearLocationMarkers = function () {

            var map = Monet.Session.RouteDetail.screensList[this.routeId].map;

            for (var layer in map._layers) {
                if (map._layers[layer].kind === 'NEAR_CUSTOMER') {
                    try {
                        map.removeLayer(map._layers[layer]);
                    } catch (e) {
                        /**
                         * Actually, I don't know why this error happens. For some reason,
                         * the layer is listed as a map layer but it is not appended in DOM
                         * tree anymore.
                         */
                    }
                }
            }

        };

        this.addToRouteModal = function (location) {

            var onAfterShowModalForm = function () {
                this.createAddToRouteModalForm.apply(this, [location]);
            }.bind(this);

            this.modal = new Monet.Form.Modal(
                '#routeMaps_' + this.routeId, {
                    width: 300,
                    height: 280
                }, {
                    onAfterShowModalForm: onAfterShowModalForm
                },
                '#routeMaps_' + this.routeId + ' .nearLocationPanelBasis');

            this.modal.showModalForm();

        };

        this.createAddToRouteModalForm = function (location) {

            var _location = location.location;
            var modalContainer = document.querySelector('#routeMaps_' + this.routeId + ' .popupFormContainer');

            var placementOptions = [{
                value: 'BEST_INSERTION',
                label: 'stop.placement.values.bestInsertion'
            }, {
                value: 'FIRST',
                label: 'stop.placement.values.first'
            }, {
                value: 'LAST',
                label: 'stop.placement.values.last'
            }];

            modalContainer.style.overflowX = 'visible';
            modalContainer.style.overflowY = 'visible';

            var optionDOM = null;
            modalContainer.innerHTML = '';

            var formContainer = document.createElement('div');
            var sizesContainer = document.createElement('div');
            var size1Container = document.createElement('div');
            var size2Container = document.createElement('div');
            var size3Container = document.createElement('div');
            var selectPosition = document.createElement('select');
            var selectPositionLabel = document.createElement('label');
            var sizeOneField = new Monet.UI.Fields.Decimal();
            var sizeTwoField = new Monet.UI.Fields.Decimal();
            var sizeThreeField = new Monet.UI.Fields.Decimal();
            var submitButton = document.createElement('input');
            var stopDetail = document.createElement('h4');

            var alert = document.createElement("div");
            alert.setAttribute("class", "alert alert-error");
            alert.style.margin = "10px";
            alert.style.display = "none";

            alert.appendChild(document.createElement("li"));
            modalContainer.appendChild(alert);

            this.stopTypeLookup = this.stopTypeLookup || new Monet.UI.Fields.Render({
                    label: Monet.I18n.getResourcesByKey('stop.stopType'),
                    name: 'stopType',
                    mandatory: true,
                    type: 'LOOKUP',
                    lookupEntity: 'StopType',
                    lookupEntityColumn: 'description'
                }, 'routeMaps_' + this.routeId).render();

            submitButton.type = 'button';
            submitButton.id = 'addStopSubmitButton';
            submitButton.value = Monet.I18n.getResourcesByKey('route.button.addStop');

            formContainer.className = 'addStopFormContainer';
            sizesContainer.className = 'modalSizesContainer';
            size1Container.className = 'addStopFieldSizesContainer';
            size2Container.className = 'addStopFieldSizesContainer';
            size3Container.className = 'addStopFieldSizesContainer';
            sizesContainer.appendChild(size1Container);
            sizesContainer.appendChild(size2Container);
            sizesContainer.appendChild(size3Container);

            sizeOneField.render();
            sizeTwoField.render();
            sizeThreeField.render();

            selectPosition.id = 'addStopselectPosition_' + this.routeId;
            sizeOneField.setId('sizeOneField_' + this.routeId);
            sizeTwoField.setId('sizeTwoField_' + this.routeId);
            sizeThreeField.setId('sizeThreeField_' + this.routeId);

            stopDetail.innerHTML = _location.key + ' - ' + _location.description;
            selectPositionLabel.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.PendingOrdersNotification.placementLabel');
            sizeOneField.setTextLabel(Monet.I18n.getResourcesByKey('globalConfiguration.size1Alias'));
            sizeTwoField.setTextLabel(Monet.I18n.getResourcesByKey('globalConfiguration.size2Alias'));
            sizeThreeField.setTextLabel(Monet.I18n.getResourcesByKey('globalConfiguration.size3Alias'));

            submitButton.addEventListener('click', (function (location, scope) {
                return function () {

                    scope.addLocationToRoute(location);

                };
            }(_location, this)));

            for (var i = 0, len = placementOptions.length; i < len; i++) {

                optionDOM = document.createElement('option');
                optionDOM.value = placementOptions[i].value;
                optionDOM.innerHTML = Monet.I18n.getResourcesByKey(placementOptions[i].label);

                selectPosition.appendChild(optionDOM);

            }

            selectPositionLabel.appendChild(selectPosition);

            size1Container.appendChild(sizeOneField.rootEl);
            size2Container.appendChild(sizeTwoField.rootEl);
            size3Container.appendChild(sizeThreeField.rootEl);

            formContainer.appendChild(stopDetail);
            formContainer.appendChild(selectPositionLabel);
            formContainer.appendChild(this.stopTypeLookup.rootEl);
            formContainer.appendChild(sizesContainer);
            formContainer.appendChild(submitButton);

            modalContainer.appendChild(formContainer);

        };

        this.addLocationToRoute = function (location) {

            var stopKey = uuid.v1();
            var placementField = document.getElementById('addStopselectPosition_' + this.routeId);
            var sizeOneField = document.querySelector('#sizeOneField_' + this.routeId +' input');
            var sizeTwoField = document.querySelector('#sizeTwoField_' + this.routeId+' input');
            var sizeThreeField = document.querySelector('#sizeThreeField_' + this.routeId+' input');
            var stopTypeId = this.stopTypeLookup.getValue().id;
            var alert = document.querySelector('.alert.alert-error');
            const submitBtn = document.querySelector('#addStopSubmitButton');

            alert.style.display = "none";
            if (stopTypeId) {
                
                this.stopTypeLookup.rootEl.className = '';

                var data = {
                    placement: placementField.value,
                    stop: {
                        key: stopKey,
                        location: {
                            id: location.id
                        },
                        stopType: {
                            id: this.stopTypeLookup.getValue().id
                        }
                    }
                };

                var decimalFormatter =  new Monet.Format.DECIMAL();
                if (sizeOneField.value.trim()) {
                    decimalFormatter.value = sizeOneField.value;
                    data.stop.plannedSize1 = decimalFormatter.parseFloat().getValue();
                }

                if (sizeTwoField.value.trim()) {
                    decimalFormatter.value = sizeTwoField.value;
                    data.stop.plannedSize2 = decimalFormatter.parseFloat().getValue();
                }

                if (sizeThreeField.value.trim()) {
                    decimalFormatter.value = sizeThreeField.value;
                    data.stop.plannedSize3 = decimalFormatter.parseFloat().getValue();
                }
                submitBtn.disabled = true;
                var request = new Monet.Ajax();
                request.url = '/Route/' + this.routeId + '/AddStop';
                request.method = 'POST';
                request.data = data;

                request.success = function () {

                    this.modal.closeModalWindow();
                    this.toggleMapSize();
                    this.refreshRoute();

                }.bind(this);

                request.error = function (e) {
                    submitBtn.disabled = false;
                    const error = JSON.parse(e.responseText);
                    const message = Monet.Form.Messages.getErrorMessageToBeDisplayed(error.errorMessages);
                    alert.innerHTML = Monet.I18n.getResourcesByKey(message);
                    alert.style.display = "block";

                    return true;
                };

                request.send();
            } else {

                alert.innerHTML = Monet.I18n.getResourcesByKey('NearLocations.stoptype.mandatory');
                alert.style.display = "block";
                this.stopTypeLookup.rootEl.className = 'error';
            }

        };

        this.refreshRoute = function () {

            var mapUpdate = new Monet.Maps.Updater();
            const tabName = Monet.Utils.GetTabName();
            var routeId = tabName.replace('RouteDetails_', '');
            const map = Monet.Session.RouteDetail.screensList[routeId].map
            var plannedRoute = new Greenmile.RouteDetail.PlannedRoute();

            mapUpdate.go();

            plannedRoute.setRouteId(routeId);
            plannedRoute.setMap(map);
            plannedRoute.removePlannedRoute();
            plannedRoute.drawPlannedRoute();

            this.LAYER_NAME = 'stops';
            const stopMarkers = new Greenmile.RouteDetail.MarkerStop(map, routeId);
            stopMarkers.removeStopsFromMap();
            stopMarkers.getStopsAndDrawOnMap();
 
            this.resizeGrid();

        };

        this.clearCurrentLocationsFromLocationList = function () {

            var locationList = this.panelBasis.querySelector('.nearLocationFilterByField');
            locationList.innerHTML = '';

        };

    }

    return NearLocations;

})();
